import { HealthcheckList, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { Navigate, useParams } from 'react-router'
import { PageBody } from '../../routes/PageBody'
import { useCurrentOrgRootPath, useOrg } from '../organization/useOrg'
import { FinchSetupHealthcheck } from './FinchSetup'
import { PayrollConnectionHealthcheck } from './PayrollConnectionInputs'
import { PayrollOpsSurveyHealthcheck } from './PayrollHealthcheck'
import { DefaultPayrollPlatformHealthcheck } from './DefaultPayrollPlatformHealthcheck'
import { usePreferredPayrollViewFromContext } from './usePreferredPayrollView'
import { NotifyChange } from '../NotifyChange'

/**
 * Hook to set the active slide to the most-actionable slide _if one is not already set_
 * 1. If Finch Connect is enabled and not connected, go to Finch setup
 * 2. If survey is not complete, go to first page of survey - basic location
 * 3. Otherwise go to work location page
 */
export const PayrollPage = () => {
  const org = useOrg()
  const currentOrgRootPath = useCurrentOrgRootPath()
  const { payrollView } = useParams()
  const preferredPayrollView = usePreferredPayrollViewFromContext()
  if (!org) return null
  if (!payrollView && preferredPayrollView && payrollView !== preferredPayrollView) {
    return <Navigate to={`${currentOrgRootPath}/payroll/${preferredPayrollView}`} replace />
  }
  const todo = !org.isOnboarded
  return (
    <PageBody maxWidth="md">
      <Typography variant="h1" gutterBottom>
        Payroll
      </Typography>
      <HealthcheckList sx={{ mb: 3 }} todo={todo} maxWidth="sm">
        <FinchSetupHealthcheck org={org} todo={todo} />
        <PayrollConnectionHealthcheck org={org} todo={todo} />
        <PayrollOpsSurveyHealthcheck org={org} todo={todo} />
        <DefaultPayrollPlatformHealthcheck org={org} todo={todo} />
      </HealthcheckList>
      <NotifyChange />
    </PageBody>
  )
}
